<app-shared-alert-message></app-shared-alert-message>
<!-- Page content -->
<div class="page-content">
    <app-layout-partial-sidebar></app-layout-partial-sidebar>
    <!-- Main content -->
    <div class="content-wrapper">
        <app-layout-partial-header></app-layout-partial-header>
        <!-- Inner content -->
        <div class="content-inner">
            <router-outlet></router-outlet>
            <!-- Footer -->
            <app-layout-partial-footer></app-layout-partial-footer>
            <!-- / Footer -->
        </div>
        <!-- / Inner content -->
    </div>
    <!-- / Main content -->
</div>
<!-- / Page content -->
